var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EDEDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04372 23.2124C7.97785 23.2128 7.91238 23.2022 7.84997 23.1812C7.71944 23.1388 7.60648 23.0546 7.52854 22.9417C7.4506 22.8287 7.41201 22.6932 7.41872 22.5562C7.41872 22.4624 8.06247 13.3874 17.1625 12.6749V9.41241C17.1624 9.28816 17.1993 9.16669 17.2685 9.06352C17.3378 8.96035 17.4362 8.88017 17.5513 8.83321C17.6663 8.78625 17.7928 8.77466 17.9144 8.7999C18.0361 8.82514 18.1475 8.88607 18.2343 8.97491L24.4031 15.2749C24.5176 15.3917 24.5818 15.5488 24.5818 15.7124C24.5818 15.876 24.5176 16.0331 24.4031 16.1499L18.2343 22.4499C18.1475 22.5388 18.0361 22.5997 17.9144 22.6249C17.7928 22.6502 17.6663 22.6386 17.5513 22.5916C17.4362 22.5447 17.3378 22.4645 17.2685 22.3613C17.1993 22.2581 17.1624 22.1367 17.1625 22.0124V18.8124C11.0875 19.0437 8.59684 22.8749 8.57184 22.9218C8.51546 23.0108 8.43747 23.0842 8.34513 23.135C8.2528 23.1858 8.14911 23.2124 8.04372 23.2124ZM18.4125 10.9437V13.2593C18.4126 13.4213 18.3497 13.5771 18.2372 13.6937C18.1247 13.8103 17.9713 13.8786 17.8093 13.8843C11.9218 14.0999 9.81559 18.0218 9.05934 20.5437C10.6218 19.1937 13.4062 17.5437 17.75 17.5437H17.7781C17.9439 17.5437 18.1028 17.6095 18.22 17.7267C18.3372 17.8439 18.4031 18.0029 18.4031 18.1687V20.4843L23.0906 15.7155L18.4125 10.9437Z",
    fill: "#534DE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/share_link.c9523f92804bf963627a65c93bd886af.svg";
export { ForwardRef as ReactComponent };